import { render } from "./SankeyChart.vue?vue&type=template&id=1f43e0a0&scoped=true"
import script from "./SankeyChart.vue?vue&type=script&lang=js"
export * from "./SankeyChart.vue?vue&type=script&lang=js"

import "./SankeyChart.vue?vue&type=style&index=0&id=1f43e0a0&scoped=true&lang=css"

import exportComponent from "/home/walter/projects/finances-vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f43e0a0"]])

export default __exports__